import * as actionTypes from 'constants/ActionTypes';

const countries = (state = {
    items: [],
    isLoaded: false,
}, action) => {
    switch (action.type) {
        case actionTypes.GET_COUNTRIES.REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_COUNTRIES.SUCCESS: {
            return {
                ...state,
                items: action.data,
                isLoaded: true,
            };
        }
        case actionTypes.GET_COUNTRIES.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };

        default:
            return state;
    }
};

export default countries;



// WEBPACK FOOTER //
// ./app/reducers/countries.js